<script setup lang="ts">
import ConfiguratorPanel from './ConfiguratorPanel.vue';
import { controller, money, setSelections } from './designerController';
import { t } from './i18n';
</script>

<template>
  <div class="veyop-sc vpsc:space-y-4 vpsc:p-1">
    <ConfiguratorPanel
      v-if="controller.profile"
      :profile="controller.profile"
      :model-value="controller.selections"
      :money="money"
      :heading="true"
      @update:model-value="setSelections"
    />
    <p class="vpsc:m-0! vpsc:text-xs vpsc:text-(--vs-ink-2)">{{ t('Your choices update the design and the price. You can still edit the design freely.') }}</p>
  </div>
</template>
